var configs = {
    text: {
        closeMenu: 'Close menu',
        closeSubmenu: 'Close submenu',
        openSubmenu: 'Open submenu',
        toggleSubmenu: 'Toggle submenu'
    }
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/screenreader/_configs.js
// module id = 100
// module chunks = 0